var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCombineField(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 17V20",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17V20",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35C33.7614 35 36 32.7614 36 30C36 27.2386 33.7614 25 31 25C28.2386 25 26 27.2386 26 30C26 32.7614 28.2386 35 31 35Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 35C11.2091 35 13 33.2091 13 31C13 28.7909 11.2091 27 9 27C6.79086 27 5 28.7909 5 31C5 33.2091 6.79086 35 9 35Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31H13",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27.0001H2V19.3401C1.99996 18.6714 2.22331 18.0219 2.63457 17.4947C3.04584 16.9675 3.62144 16.5928 4.27 16.4301L11.13 14.7201C13.0492 14.2375 15.021 13.9956 17 14.0001H33",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35H40V28H41L48 34V35Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 20H25L21 23H2",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20V12L28.59 9.65003C28.7045 9.19043 28.9785 8.78639 29.3631 8.50987C29.7476 8.23335 30.2178 8.10229 30.69 8.14003L41 9.00003",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20L38 9",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20L34 9",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20V27",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23 14V12.6C23.0005 11.8249 22.7759 11.0664 22.3534 10.4167C21.9308 9.76691 21.3286 9.2539 20.62 8.94L15.94 6.86C14.6617 6.29258 13.2786 5.9996 11.88 6H1",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_763_10233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79358 54.8799C5.70078 54.2639 6.61917 53.6479 7.54877 53.0655C9.57597 51.7775 11.6704 50.5679 13.8096 49.4479C15.9488 48.3279 18.1776 47.2079 20.4288 46.3007C22.68 45.3935 25.0544 44.4527 27.44 43.6687C36.2954 40.7467 45.5551 39.2349 54.88 39.1887",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2496 54.8799C25.931 47.6253 40.2705 43.7675 54.88 43.6799",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.24 54.8799C33.2177 50.5047 43.9853 48.2178 54.88 48.1599",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.88 52.64C48.8719 52.6698 42.8893 53.4218 37.0608 54.88",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12 39.2H54.88",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12 43.6799H27.3504",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12 48.1599H16.2848",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_763_10233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.7712,
    height: 17.8864,
    fill: "white",
    transform: "translate(1.12 38.08)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombineField);
export default __webpack_public_path__ + "static/media/combineField.db0cceaf1485e180a51d88017c457dd9.svg";
export { ForwardRef as ReactComponent };